import { Dialog, DialogContent } from '../../components/dialog.js'
import { YouTubePlayer } from '../VideoModal/YouTubePlayer.js'

export interface VideoModalType extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  visible: boolean
  youTubeId?: string
  videoUrl?: string
  onCloseModal: () => void
}

const VideoModal = (props: VideoModalType) => {
  const { visible, youTubeId, videoUrl, onCloseModal, className, ...rest } = props

  return (
    <Dialog open={visible} onOpenChange={() => onCloseModal()}>
      <DialogContent className="max-h-3/4 h-3/4 w-4/5 max-w-[1200px] border-none bg-transparent p-0 [&_button]:hidden">
        {youTubeId ? (
          <YouTubePlayer youTubeId={youTubeId} />
        ) : videoUrl ? (
          <video
            className="size-full overflow-hidden rounded-2xl object-cover"
            src={videoUrl}
            muted
            loop
            autoPlay
            controls
          />
        ) : null}
        <div
          onClick={() => onCloseModal()}
          className="tablet:size-8 tablet:-right-8 tablet:-top-8 absolute -right-6 -top-6 size-6 cursor-pointer overflow-hidden text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
            data-slot="icon"
            className="HomeCharger_closeWrap__Z7aBo"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12"></path>
          </svg>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { VideoModal }
